import { useEffect, useState } from "react";
import Dates from "../Movies/Dates";
import "./billboard.css";
import Movies from "../Movies/Movies";
import { getApiRoute } from "../../utils/apiRoute";
import { userStore } from "../../store/userStore";


export default function Billboard() {
  const kioskData = userStore((state) => state.kioskData);
  const api = getApiRoute();
  const [datesLoading, setDatesLoading] = useState(true);
  const [billboardLoading, setBillboardLoading] = useState(true);
  const [dates, setDates] = useState([]);
  const [billboard, setBillboard] = useState([]);
  const [date, setDate] = useState("");

  const getData = async (url) => {
    try {
      let data = await fetch(url);
      data = await data.json();
      return data;
    } catch (error) {
      console.error(error);
      return null;
    }
  };

  const getBillboard = async (date = null) => {
    const theater = kioskData.complement.theater.name || "viziona";

    setBillboardLoading(true);
    let route = `movies/theater/${theater}/showtimes`;

    if (date) {
      route += `?date=${date}`;
    }

    let billboard = await getData(`${api}${route}`);
    setBillboard(billboard.data || []);
    setBillboardLoading(false);
  };

  const selectDate = (date) => {
    setDate(date);
    getBillboard(date);
  };

  useEffect(() => {
    if (!api) return;

    if (datesLoading) {
      const getDatesData = async () => {
        let response = await getData(`${api}dates/viziona`);
        let dates = null;

        if (response) {
          const {
            data: { dates: responseDates },
          } = response;
          dates = responseDates;

          let firstDate = dates[0].function_date;
          setDate(firstDate);
          getBillboard(firstDate);
        }

        setDates(dates);
        setDatesLoading(false);
      };
      getDatesData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [api, datesLoading]);

  return (
    <div className="billboard">
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-12">
            <Dates
              loading={datesLoading}
              dates={dates}
              currentDate={date}
              selectDate={selectDate}
            />
            <Movies loading={billboardLoading} movies={billboard} />
          </div>
        </div>
      </div>
    </div>
  );
}
